var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TaxCode } from "./TaxCode";
import { Condition } from "./Condition";
export class TaxCodeDefinition {
  constructor(_data) {
    /**
     */
    __publicField(this, "Conditions");
    /**
     */
    __publicField(this, "Enabled");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "ReturnType");
    /**
     */
    __publicField(this, "TaxCode");
    /**
     */
    __publicField(this, "TaxCodeStr");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof TaxCodeDefinition
     */
    __publicField(this, "$type", "V1.TaxCodeDefinitions.TaxCodeDefinition");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Conditions"] && _data["Conditions"].constructor === Array) {
        this.Conditions = [];
        for (let item of _data["Conditions"]) {
          const conditions_ = new Condition();
          this.Conditions.push(conditions_.init(item));
        }
      }
      this.Enabled = _data["Enabled"];
      this.Id = _data["Id"];
      this.ReturnType = TaxCodeDefinitionReturnType[_data["ReturnType"]];
      if (_data["TaxCode"]) {
        const taxCode_ = new TaxCode();
        this.TaxCode = taxCode_.init(_data["TaxCode"]);
      }
      this.TaxCodeStr = _data["TaxCodeStr"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.Conditions && this.Conditions.constructor === Array) {
      _data["Conditions"] = [];
      for (let item of this.Conditions) {
        _data["Conditions"].push(item.toJSON());
      }
    }
    _data["Enabled"] = this.Enabled;
    _data["Id"] = this.Id;
    _data["ReturnType"] = TaxCodeDefinitionReturnType[this.ReturnType];
    _data["TaxCode"] = this.TaxCode ? this.TaxCode.toJSON() : void 0;
    _data["TaxCodeStr"] = this.TaxCodeStr;
    return _data;
  }
}
export var TaxCodeDefinitionReturnType = /* @__PURE__ */ ((TaxCodeDefinitionReturnType2) => {
  TaxCodeDefinitionReturnType2["VATOrOSS"] = "VATOrOSS";
  TaxCodeDefinitionReturnType2["IOSS"] = "IOSS";
  return TaxCodeDefinitionReturnType2;
})(TaxCodeDefinitionReturnType || {});
